import { render, staticRenderFns } from "./changeImgDialog.vue?vue&type=template&id=6ba78178"
import script from "./changeImgDialog.vue?vue&type=script&lang=js"
export * from "./changeImgDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports